import { render } from "./ContatoModal.vue?vue&type=template&id=f5726816&scoped=true"
import script from "./ContatoModal.vue?vue&type=script&lang=js"
export * from "./ContatoModal.vue?vue&type=script&lang=js"

import "./ContatoModal.vue?vue&type=style&index=0&id=f5726816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5726816"]])

export default __exports__